<mat-card class="deadlines-card" data-testid="event-announcements-card">
  <mat-card-header class="deadlines-header">
    <mat-card-title>Event Announcements</mat-card-title>
  </mat-card-header>

  <mat-divider></mat-divider>

  <mat-card-content class="deadlines-content">
    @if (activeEvents().length === 0) {
      <div class="hm-deadline-item empty-state" data-testid="event-announcements-empty">
        <p>No upcoming events shared with you.</p>
      </div>
    }

    @for (event of visibleEvents(); track event.id; let last = $last) {
      <div
        class="hm-deadline-item"
        (click)="openDetail(event)"
        style="cursor: pointer"
        [attr.data-testid]="'announcement-event-' + event.id"
      >
        <span class="date-badge" [ngClass]="badgeClass(event)">{{ dateLabel(event) }}</span>
        <h5>{{ event.title }}</h5>
        <p>
          @if (event.place) {
            {{ event.place }} ·
          }
          {{ timeLabel(event) }}
        </p>
        @if (event.description) {
          <p class="event-description">{{ event.description }}</p>
        }
        <div class="hm-deadline-actions">
          <button
            mat-flat-button
            [class]="isAttending(event) ? 'btn-attending-sm' : 'btn-choice-sm'"
            [attr.aria-pressed]="isAttending(event)"
            (click)="respond(event, 'confirmed'); $event.stopPropagation()"
            [attr.aria-label]="'Attending ' + event.title"
            [attr.data-testid]="'attend-btn-' + event.id"
          >
            @if (isAttending(event)) {
              ✓ Attending
            } @else {
              Attending
            }
          </button>
          <button
            mat-flat-button
            [class]="isDeclined(event) ? 'btn-declined-sm' : 'btn-choice-sm'"
            [attr.aria-pressed]="isDeclined(event)"
            (click)="respond(event, 'declined'); $event.stopPropagation()"
            [attr.aria-label]="'Not attending ' + event.title"
            [attr.data-testid]="'decline-btn-' + event.id"
          >
            Not Attending
          </button>
        </div>
      </div>
      @if (!last) {
        <mat-divider></mat-divider>
      }
    }
  </mat-card-content>

  @if (activeEvents().length > 3) {
    <mat-divider></mat-divider>
    <button
      mat-button
      class="show-more-btn"
      (click)="toggleShowAll()"
      [attr.aria-label]="showAll() ? 'Show fewer events' : 'Show all events'"
      data-testid="show-more-btn"
    >
      {{ showAll() ? '▲ Show less' : '▼ Show all ' + activeEvents().length + ' events' }}
    </button>
  }

  <mat-divider></mat-divider>

  <mat-card-actions class="deadlines-footer">
    <a
      mat-button
      routerLink="/students/calendar"
      class="footer-link"
      aria-label="View full calendar"
      data-testid="view-calendar-link"
    >
      View full calendar →
    </a>
  </mat-card-actions>
</mat-card>
